import { apiRoutes, contentfulRoutes } from "routes";
import FetchHelpers from "utils/FetchHelpers";

export default {
  show(slug) {
    const url = FetchHelpers.toCDN(apiRoutes.templateGroupPath(1, slug));
    return FetchHelpers.get(url);
  },
  contentfulShow(slug, withDraft) {
    const url = contentfulRoutes.templateGroup(slug);
    const headers = { Accept: "application/vnd.api+json" };
    const params = {};
    if (withDraft && withDraft === "true") params.filter = { "with-draft": true };
    return FetchHelpers.get(url, params, headers);
  },
};
